module.exports = require("babel-runtime/helpers/createClass");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/helpers/createClass"
// module id = 4
// module chunks = 0